import * as React from 'react';
import './StatusTab.scss';
import Accordion from 'src/components/common/Accordion';
import TableHeader from 'src/components/common/TableHeader';
import StatusHeader from './components/StatusHeader';
import ExpandableDesktop from './components/ExpandableDesktop';
import ExpandableMobile from './components/ExpandableMobile';
import Loader from 'src/components/common/Loader';
import TablePagination from 'src/components/common/TablePagination';
import FiltersBarDesktop from '../FiltersBarDesktop';
import FiltersBarMobile from '../FiltersBarMobile';
import './StatusTab.scss';
import { IStatusResponse, IReturnAlert } from 'src/services/returns/typings';
import { IRmaModalData } from '../../ReturnsView';
import Alert from 'src/components/common/Alert';
import ResultsCounter from '../ResultsCounter';
import i18n from 'src/translation/i18n';
import CustomPaginator from 'src/components/common/CustomPaginator';
import Button from '@material-ui/core/Button';
import exportIcon from '../../../../assets/export';
import downarrowIcon from '../../../../assets/downArrow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';

export enum ERmaStatus {
  IN_PROGRESS = 'IN PROGRESS',
  COMPLETED = 'COMPLETED',
  NOT_SUBMITTED = 'NOT SUBMITTED',
  REJECTED_DAMAGE = 'REJECTED DAMAGE',
  REJECTED_MISSING = 'REJECTED MISSING',
  REJECTED_INSTALLED = 'REJECTED INSTALLED',
  CANCELLED = 'CANCELLED',
  PARTIALLY_CANCELLED = 'PARTIALLY CANCELLED'
}

interface IStatusTabProps {
  handlePagination: (type: string) => void;
  handleSortItemsStatus: (option: string) => void;
  sortBy: string[];
  isPending: boolean;
  statusData: IStatusResponse;
  handleShowRmaModal: (state: boolean, rmaModalData: IRmaModalData) => void;
  setSelectedReturnToDelete: (id: string) => void;
  selectedTypeOfItem: string;
  handleSelectedTypeOfItemChange: (type: any) => void;
  handleClickSearch: (searchBy: string, query: string) => void;
  setSortEligible: (values: string[]) => void;
  closeAlert: () => void;
  returnStatusAlert: IReturnAlert;
  filter: string;
  setFilter: (value: string) => void;
  showCounter: boolean;
  forItem: string;
  clearFilters: () => void;
  clearEligibleFilters: () => void;
  downloadPdf: (rmaNumber: string) => void;
  isDownloadingPdf: boolean;
  handleDesktopPaginationStatus?(event: any): void;
  handlePageSizeChangeStatus?(event: any): void;
  handleMenuItemClickReturnStatus: (event: any, index:number) => void;
}

const Section = (props: {
  identifier: string;
  header: any;
  children?: any;
}) => {
  return <div>{props.children}</div>;
};

interface IFilterByOption {
  value: '' | ERmaStatus;
  label: string;
}

const StatusTab: React.FC<IStatusTabProps> = props => {
  const {
    statusData,
    isPending,
    handlePagination,
    handleSortItemsStatus,
    sortBy,
    handleShowRmaModal,
    handleSelectedTypeOfItemChange,
    handleClickSearch,
    setSortEligible,
    selectedTypeOfItem,
    setSelectedReturnToDelete,
    returnStatusAlert,
    closeAlert,
    filter,
    setFilter,
    showCounter,
    forItem,
    clearFilters,
    downloadPdf,
    isDownloadingPdf,
    clearEligibleFilters,
    handleDesktopPaginationStatus,
    handlePageSizeChangeStatus,
    handleMenuItemClickReturnStatus
  } = props;

  const [selectedSearchBy, setSelectedSearchBy] = React.useState<string>('partNumber');
  const [searchQuery, setSearchQuery] = React.useState<string>('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const exportOptions = [
    { label: `${i18n.t('invoices.exportasXLSX')}`, value: 'xlsx' },
    { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf' },
    { label: `${i18n.t('invoices.exportasCSV')}`, value: 'csv' }
  ];

  React.useEffect(() => {
    setSearchQuery(forItem);

    return () => {
      closeAlert();
    };
  }, [forItem]);

  const handleSelectedSearchBy = (searchBy: string) => {
    setSelectedSearchBy(searchBy);
  };

  const handleSearchQuery = (str: string) => {
    setSearchQuery(str);
  };

  const onClickSearch = () => {
    handleClickSearch(selectedSearchBy, searchQuery);
  };

  const headers = [
    {
      id: 'returnNo',
      name: `${i18n.t('myReturns.returnNo')}`,
      spaces: 2,
      isSortable: false
    },
    {
      id: 'poNumber',
      name: `${i18n.t('myReturns.pONumber')}`,
      spaces: 2,
      isSortable: false
    },
    {
      id: 'status',
      name: `${i18n.t('myReturns.status')}`,
      spaces: 2,
      isSortable: true
    },
    {
      id: 'submittedOn',
      name: `${i18n.t('myReturns.SubmittedOn')}`,
      spaces: 2,
      isSortable: true
    },
    {
      id: 'creditedOn',
      name: `${i18n.t('myReturns.creditedOn')}`,
      spaces: 2,
      isSortable: true
    }
  ];

  const filterByOptions: IFilterByOption[] = [
    { value: '', label: `${i18n.t('common.allStatuses')}` },
    { value: ERmaStatus.COMPLETED, label: `${i18n.t('status.completed')}` },
    { value: ERmaStatus.IN_PROGRESS, label: `${i18n.t('status.inProgress')}` },
    { value: ERmaStatus.NOT_SUBMITTED, label: `${i18n.t('status.notSubmitted')}`},
    { value: ERmaStatus.CANCELLED, label: `${i18n.t('status.cancelled')}`},
    { value: ERmaStatus.PARTIALLY_CANCELLED, label: `${i18n.t('status.partiallyCancelled')}`}
  ];

  const handleClickListItem = (event: any) => {
    setAnchorEl(event.currentTarget);
 };
 const handleClose = () => {
  setAnchorEl(null);
};

const handleMenuItemClickPre=(event:any,index:number)=>{
  setAnchorEl(null);
  handleMenuItemClickReturnStatus(event,index)
}

  return (
    <>
      {isPending ? (
        <Loader />
      ) : (
        <div className="rp-status-tab">
          {returnStatusAlert.show && (
            <Alert
              type={returnStatusAlert.type}
              styleClass="rp-status-tab-alert"
              message={returnStatusAlert.message}
              icon={returnStatusAlert.icon}
              handleCloseAlert={closeAlert}
            />
          )}
          <div className="rp-status-tab-filterbar-mobile">
            <h2 className="rp-status-tab-heading">
              {i18n.t('myReturns.returnStatus')}
            </h2>
            <FiltersBarMobile
              typeOfItemOptions={[
                { value: 'part', label: `${i18n.t('myReturns.part')}` },
                { value: 'usedCore', label: `${i18n.t('myReturns.usedCore')}` }
              ]}
              selectedTypeOfItem={selectedTypeOfItem}
              onSelectedTypeOfItemChange={handleSelectedTypeOfItemChange}
              filterByOptions={filterByOptions}
              selectedFilterBy={filter}
              onSelectedFilterByChange={setFilter}
              searchByOptions={[
                { value: 'partNumber', label: `${i18n.t('myReturns.partNo')}` },
                {
                  value: 'invoiceNumber',
                  label: `${i18n.t('myReturns.invoiceNo')}`
                },
                {
                  value: 'rmaNumber',
                  label: `${i18n.t('myReturns.returnNo')}`
                },
                { value: 'poNumber', label: `${i18n.t('myReturns.poNo')}` }
              ]}
              selectedSearchBy={selectedSearchBy}
              onSelectedSearchByChange={handleSelectedSearchBy}
              searchQuery={searchQuery}
              onSearchQueryChange={handleSearchQuery}
              onSearchButtonClick={onClickSearch}
              sortBy={sortBy}
              setSortBy={setSortEligible}
              handleSortItemsStatus={handleSortItemsStatus}
            />
            {showCounter && (
              <ResultsCounter
                clearFilters={clearFilters}
                resultsQuantity={statusData.totalElements}
                item={forItem}
              />
            )}


          </div>
          <div className="rp-status-tab-filterbar-desktop">
            <FiltersBarDesktop
              typeOfItemOptions={[
                { value: 'part', label: `${i18n.t('myReturns.part')}` },
                { value: 'usedCore', label: `${i18n.t('myReturns.usedCore')}` }
              ]}
              selectedTypeOfItem={selectedTypeOfItem}
              onSelectedTypeOfItemChange={handleSelectedTypeOfItemChange}
              filterByOptions={filterByOptions}
              selectedFilterBy={filter}
              onSelectedFilterByChange={setFilter}
              searchByOptions={[
                { value: 'partNumber', label: `${i18n.t('myReturns.partNo')}` },
                {
                  value: 'invoiceNumber',
                  label: `${i18n.t('myReturns.invoiceNo')}`
                },
                {
                  value: 'rmaNumber',
                  label: `${i18n.t('myReturns.returnNo')}`
                },
                { value: 'poNumber', label: `${i18n.t('myReturns.poNo')}` }
              ]}
              selectedSearchBy={selectedSearchBy}
              onSelectedSearchByChange={handleSelectedSearchBy}
              searchQuery={searchQuery}
              onSearchQueryChange={handleSearchQuery}
              onSearchButtonClick={onClickSearch}
            />
            {showCounter && (
              <ResultsCounter
                clearFilters={clearFilters}
                resultsQuantity={statusData.totalElements}
                item={forItem}
              />
            )}
           
          {statusData.data.length >0 &&
          <span className="export-icon-return-menu"> 
            <Button
              aria-controls="fade-menu"
              aria-haspopup="true"
              onClick={handleClickListItem}
              disabled={null}
            >
              <img className="image-icon" src={exportIcon} />
              <img className="down-arrow" src={downarrowIcon} />
            </Button>
            </span>
            }
            {statusData.data.length >0 &&
            <Menu
              id="fade-menu"
              anchorEl={anchorEl}
              keepMounted={true}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              TransitionComponent={Fade}
            >
              {exportOptions.map((exportoptions, index) => (
                <MenuItem
                  key={exportoptions.value}
                  // selected={index === index}
                  onClick={event => handleMenuItemClickPre(exportoptions.value, index)}
                >
                  {exportoptions.label}
                </MenuItem>
              ))}
            </Menu>
            }
          </div>
          <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={statusData.pageNumber ? statusData.pageNumber + 1 : 1}
              totalPages={statusData.totalPages}
              itemsPerPage={statusData.pageSize}
              onPageChanged={handleDesktopPaginationStatus}
              totalItems={statusData.totalPages * statusData.pageSize}
              showPageInfo={true}
              onPageSizeChange={handlePageSizeChangeStatus}
              showPageRangeChange={true}
              currentPageSize={statusData.pageSize}
            />
          </div>
          <div className="rp-product-status-mobile-paginator">
          {statusData.data.length >0 &&
          <span className="export-icon-return-menu"> 
            <Button
              aria-controls="fade-menu"
              aria-haspopup="true"
              onClick={handleClickListItem}
              disabled={null}
            >
              <img className="image-icon" src={exportIcon} />
              <img className="down-arrow" src={downarrowIcon} />
            </Button>
            </span>
            }
            {statusData.data.length >0 &&
            <Menu
              id="fade-menu"
              anchorEl={anchorEl}
              keepMounted={true}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              TransitionComponent={Fade}
            >
              {exportOptions.map((exportoptions, index) => (
                <MenuItem
                  key={exportoptions.value}
                  // selected={index === index}
                  onClick={event => handleMenuItemClickPre(exportoptions.value, index)}
                >
                  {exportoptions.label}
                </MenuItem>
              ))}
            </Menu>
            }
            <TablePagination
              handlePagination={handlePagination}
              pagination={{
                pageNumber: statusData.pageNumber,
                pageSize: statusData.pageSize,
                totalPages: statusData.totalPages
              }}
            />
          </div>
          <Accordion
            showHandleCollapse={true}
            allowMultipleOpen={true}
            startExpanded={false}
            expandAllChild={null}
            header={
              <TableHeader
                headers={headers}
                handleSortBy={handleSortItemsStatus}
                sortBy={sortBy}
              />
            }
          >
            {statusData.data.map(status => (
              <Section
                identifier={status.rmaNumber}
                header={<StatusHeader status={status} />}
                key={status.rmaNumber}
              >
                <ExpandableDesktop
                  statusData={status}
                  handleShowRmaModal={handleShowRmaModal}
                  setSelectedReturnToDelete={setSelectedReturnToDelete}
                  downloadPdf={downloadPdf}
                  isDownloadingPdf={isDownloadingPdf}
                  clearEligibleFilters={clearEligibleFilters}
                />
                <ExpandableMobile
                  statusData={status}
                  handleShowRmaModal={handleShowRmaModal}
                  setSelectedReturnToDelete={setSelectedReturnToDelete}
                  downloadPdf={downloadPdf}
                  isDownloadingPdf={isDownloadingPdf}
                  clearEligibleFilters={clearEligibleFilters}
                />
              </Section>
            ))}
          </Accordion>
          <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={statusData.pageNumber ? statusData.pageNumber + 1 : 1}
              totalPages={statusData.totalPages}
              itemsPerPage={statusData.pageSize}
              onPageChanged={handleDesktopPaginationStatus}
              totalItems={statusData.totalPages * statusData.pageSize}
              showPageInfo={true}
              onPageSizeChange={handlePageSizeChangeStatus}
              showPageRangeChange={true}
              currentPageSize={statusData.pageSize}
            />
          </div>
          <div className="rp-product-status-mobile-paginator">
          
            <TablePagination
              handlePagination={handlePagination}
              pagination={{
                pageNumber: statusData.pageNumber,
                pageSize: statusData.pageSize,
                totalPages: statusData.totalPages
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default StatusTab;
